<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import VehicleDrivers from "./VehicleDrivers.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import {setFocusTo, scrollTo} from "../lib/lib";


    export let vehicleId = null;
    export let changeCallback;
    export let breadcrumb = [];

    export let transporter = null;

    let vehicle = null;
    let pageTitle = '';
    let error = false;

    const initialize = () => {
        if (transporter) {
            breadcrumb = [...breadcrumb, {id: 'transporter', name: transporter.name}];
        }

        scrollTo('top');

        if (vehicleId == 0 || vehicleId == 'create') {
            vehicle = {
                id: 0,
                licence_no: '',
                vehicle_type_id: 0,
                transporter_id: transporter.id,
                is_active: 1,
                drivers: [],
            }
            vehicleId = 0;
            pageTitle = "New Vehicle";
            setFocusTo('licenceNo');
        } else {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            vehicle = result;
            pageTitle = vehicle.licence_no;
            setFocusTo('licenceNo');
        }

        const onFailure = err => {
            error = true;
        };

        R.handle(R.vehicle.details, vehicleId, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            vehicle = result;
            vehicleId = result.id;
            pageTitle = vehicle.licence_no;
            changeCallback(vehicle);
            Notifier.showMessage("Vehicle saved");
        }

        const onFailure = err => {
            Alert.warning("Vehicle", err.message);
        };

        if (vehicle.vehicle_type_id == 0) {
            Notifier.showError("Select the type of the vehicle!");
            return;
        }

        vehicle.licence_no = vehicle.licence_no.trim();
        if (!vehicle.licence_no) {
            Notifier.showError("Enter the licence number of the vehicle!");
            return;
        }

        let action = vehicle.id === 0 ? 'create' : 'edit';
        R.handle(R.vehicle[action], vehicle, onSuccess, onFailure, LOADER.POPUP);
    }

    const driversChange = (drivers) => {
        vehicle.drivers = drivers;
        changeCallback(vehicle);
    }

    const close = () => {
        changeCallback();
    }

    initialize();
</script>

{#if !transporter}
    <Breadcrumb {breadcrumb}/>
{/if}
{#if vehicle}
    <PageHeader title="{ pageTitle }" subtitle="{ transporter ? transporter.name : '' }"/>
    <div class="row">
        <div class="col-xl-3 col-lg-6 col-md-6">
            <div class="panel border-default mb-5">
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <h5>Licence No</h5>
                        <input type="text" class="form-control" id="licenceNo" bind:value="{ vehicle.licence_no }"
                               required>
                    </div>
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-select" bind:value="{ vehicle.vehicle_type_id }">
                            <option value="0">select</option>
                            {#each $app.vehicle_types as type}
                                <option value="{ type.id }">{ type.name }</option>
                            {/each}
                        </select>
                    </div>

<!--                    <hr>-->
<!--                    <div class="form-group">-->
<!--                        <label>Notes</label>-->
<!--                        <textarea class="form-control" bind:value="{ hotel.notes }"></textarea>-->
<!--                    </div>-->
                    <div class="form-group">
                        <Checkbox label="Active vehicle" bind:checked={ vehicle.is_active }/>
                    </div>

                    <hr>
                    <div class="text-end">
                        {#if transporter}
                            <button class="btn btn-link" on:click="{ close }">back to transporter</button>
                        {/if}
                        <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-5 col-md-6">
            <VehicleDrivers {vehicle} changeHandler="{ driversChange }"/>
        </div>
    </div>
{/if}
{#if error}
    <PageNotFound message="Vehicle not found!"/>
{/if}
